import { CartAddEvent } from '@theme/events';

const randomString = length => {
    return Array.from(Array(length), () => Math.floor(Math.random() * 36).toString(36)).join('');
}
  
class BundleTemplate extends HTMLElement {
    constructor() {
        super();

        this.bundleParentId = this.dataset.bundleParentId;

        this.submitBtn = this.querySelector('.js-add-bundle-to-cart');
        this.errorEl = this.querySelector('.error-handler');

        this.selectors = this.querySelectorAll('[name="grid product variants"]');
        this.soldOutItems = this.querySelectorAll('[data-bundle-sold-out], .product-card--bundle-sold-out');
        this.selectors.forEach((selector) => {
            selector.addEventListener('change', (e) => this.validateSelectors());
        });
        this.validateSelectors();

        if (!this.submitBtn) return;
        this.submitBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.validateForm();
        });
    }

    validateSelectors() {
        if (!this.submitBtn) return;
        this.submitBtn.disabled = true;

        if (this.soldOutItems.length > 0) {
            this.submitBtn.textContent = 'Some bundle items are sold out';
            return;
        }

        const unselected = [...this.selectors].filter((el) => el.value === null || el.value === 'undefined' || el.value === '');
        if (unselected.length === 0) {
            this.submitBtn.textContent = "Add bundle to cart";
            this.submitBtn.removeAttribute('disabled');
        return;
        }

        this.submitBtn.textContent = `Please select (${unselected.length}) option${unselected.length > 1 ? 's' : ''}`;
    }

    validateForm() {
        if (this.soldOutItems.length > 0) {
            this.errorEl.textContent = 'This bundle contains sold out items and cannot be added to cart.';
            return;
        }
        
        let bundleContents = [];
        [...this.selectors].forEach(selector => {
            bundleContents.push(selector.value);
        })

        if(bundleContents.length !== this.selectors.length) {
            this.errorEl.textContent = 'Please select all options.';
            return;
        }

        // Remove duplicates
        const uniqueBundleContents = [...new Set(bundleContents)];

        this.addToCart(uniqueBundleContents);
    }

    async addToCart(bundleContents) {
        if (!this.bundleParentId) return;
        const uniqueId = randomString(6);
        if(this.submitBtn) {
            this.submitBtn.classList.add('btn--loading');
        }

        let items = [
            {
                id: this.bundleParentId,
                quantity: 1,
                properties: {
                    '_bundle_contents_variants': bundleContents.join(','),
                    '_bundle_id': uniqueId
                }
            }
        ]

        try {
            const res = await fetch('/cart/add.js', {
                method: "POST",
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                items: items
                })
            });

            if (res.ok) {
                this.success();
            }
        }
        catch (error) {
            console.error(error);
            if(this.errorEl) {
                this.errorEl.textContent = 'An error occurred while adding the bundle to the cart.';
            }
        }
        finally {
            if (this.submitBtn) {
                this.submitBtn.classList.remove('btn--loading');
            }
        }
    }

    success() {
        const errors = this.errorEl;
        if (errors) {
            errors.remove();
        }

        document.dispatchEvent(
            new CartAddEvent({}, this.bundleParentId, {
              source: 'bundle-template',
              itemCount: 1,
            })
          );
    }

}

customElements.define('bundle-template', BundleTemplate);
  
